"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacilitiesToggle = FacilitiesToggle;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Accordion2 = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionDetails2 = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _AccordionSummary2 = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Switch2 = _interopRequireDefault(require("@mui/material/Switch"));
var _InfoOutlined2 = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _ExpandMore2 = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _facilitiesLegend = require("./facilities-legend");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function FacilitiesToggle({
  facilitiesShowed,
  selectedFacilities,
  toggleFacilities,
  ...props
}) {
  const [expended, expend] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_Accordion2.default, _extends({
    expanded: expended,
    onChange: () => expend(!expended)
  }, props, {
    sx: {
      borderRadius: '16px !important',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 'calc(100% - 16px)',
      pointerEvents: 'initial',
      width: 360,
      '&&': {
        '.MuiCollapse-root.MuiCollapse-entered': {
          flexGrow: 1,
          overflowY: 'auto !important'
        }
      },
      ...props.sx
    }
  }), /*#__PURE__*/_react.default.createElement(_AccordionSummary2.default, {
    "aria-controls": "facilities-legend",
    "aria-label": "Expand",
    expandIcon: expended ? /*#__PURE__*/_react.default.createElement(_ExpandMore2.default, null) : /*#__PURE__*/_react.default.createElement(_InfoOutlined2.default, null),
    id: "facilities-header",
    sx: {
      '&&': {
        '&.Mui-expanded': {
          flexShrink: 0,
          minHeight: 48
        },
        '.MuiAccordionSummary-content.Mui-expanded': {
          margin: '12px 0'
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    "aria-label": "Enable",
    control: /*#__PURE__*/_react.default.createElement(_Switch2.default, {
      checked: facilitiesShowed,
      color: "primary",
      size: "small"
    }),
    label: /*#__PURE__*/_react.default.createElement(StyledAccordionSummaryLabel, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.facilities_label"
    })),
    onChange: (_, showed) => {
      try {
        localStorage.setItem('display_facilities', showed ? 'true' : 'false');
      } catch {
        console.error('localStorage access is denied');
      }
      toggleFacilities(showed);
    },
    onClick: event => event.stopPropagation(),
    onFocus: event => event.stopPropagation(),
    value: facilitiesShowed
  })), /*#__PURE__*/_react.default.createElement(_AccordionDetails2.default, null, /*#__PURE__*/_react.default.createElement(_facilitiesLegend.FacilitiesLegend, {
    enableDescriptions: true,
    selectedFacilities: selectedFacilities
  })));
}
const StyledAccordionSummaryLabel = (0, _styledComponents.styled)(_Typography2.default)`
  && {
    margin-left: 8px;
  }
`;